/* eslint-disable no-nested-ternary */
import { cn } from "@/lib/utils";
import type { InteractiveElementScore } from "@/lib/interactiveElementState";

interface QuizResultSummaryProps {
  score?: InteractiveElementScore;
  /** Compact inline badge (used in the completed-state preview); otherwise a card. */
  compact?: boolean;
}

type Tone = "success" | "error" | "info";

const toneStyles: Record<Tone, string> = {
  success: "bg-success-light border-success-border text-success-foreground",
  error: "bg-error-light border-error-border text-error-foreground",
  info: "bg-info-light border-info-border text-info-foreground",
};

const QuizResultSummary = ({ score, compact }: QuizResultSummaryProps) => {
  if (!score || score.total === 0) {
    return (
      <div
        className={cn(
          "inline-flex items-center rounded-full border bg-muted px-3 py-1 font-semibold text-foreground",
          !compact && "rounded-lg px-4 py-3"
        )}
      >
        <span>Bearbeitet</span>
      </div>
    );
  }

  const { correct, total } = score;
  const single = total === 1;

  let tone: Tone;
  if (correct === total) {
    tone = "success";
  } else if (correct === 0) {
    tone = "error";
  } else {
    tone = "info";
  }

  const label = single
    ? correct === 1
      ? "Richtig"
      : "Falsch"
    : `${correct}/${total} richtig`;

  return (
    <div
      className={cn(
        "inline-flex items-center rounded-full border px-3 py-1 font-semibold",
        toneStyles[tone],
        !compact && "rounded-lg px-4 py-3"
      )}
    >
      <span>{label}</span>
    </div>
  );
};

export default QuizResultSummary;
